import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import "./home.css";
import "./HomePageView.css";

const TOP_BAYANS_COUNT = 3;

const HomePageView = () => {
  const [bayans, setBayans] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchTopFridayBayans = async () => {
      try {
        const response = await axios.get(`${apiUrl}/get-recordings/friday`, {
          params: { page: 1 },
        });
        const data = Array.isArray(response.data) ? response.data : [];
        setBayans(data.slice(0, TOP_BAYANS_COUNT));
      } catch (err) {
        console.error("Error fetching Friday bayans:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopFridayBayans();
  }, [apiUrl]);

  return (
    <section className="home-friday-bayans">
      <div className="home-friday-bayans-inner">
        <h2 className="home-friday-bayans-title">Latest Friday Bayans</h2>
        <p className="home-friday-bayans-subtitle">
          Listen to the most recent bayanats from our Friday sermons
        </p>

        {loading ? (
          <div className="home-friday-bayans-loading">Loading bayans...</div>
        ) : bayans.length === 0 ? (
          <div className="home-friday-bayans-empty">No Friday bayans available yet.</div>
        ) : (
          <div className="home-friday-bayans-grid">
            {bayans.map((bayan, index) => (
              <div key={bayan.id || index} className="home-friday-bayan-card">
                <div className="home-friday-bayan-card-body">
                  <h3 className="home-friday-bayan-card-title">{bayan.title}</h3>
                  {bayan.date && (
                    <p className="home-friday-bayan-card-date">{bayan.date}</p>
                  )}
                  <div className="home-friday-bayan-card-player">
                    <ReactPlayer
                      url={bayan.downloadURL}
                      controls
                      width="100%"
                      height="48px"
                    />
                  </div>
                  <Link
                    to={`/bayan/${bayan.id}`}
                    className="home-friday-bayan-card-link"
                  >
                    Open full page
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && bayans.length > 0 && (
          <div className="home-friday-bayans-cta">
            <Link to="/fridaybayan" className="home-friday-bayans-cta-btn">
              Listen to all Friday Bayans
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default HomePageView;
